'use client';

import { createContext } from 'react';

import type { BehaviorSubject, Subject } from 'rxjs';

import type { ChatStorageManager } from '../../functions/storage/ChatStorageManager';
import type { ChatEvent } from '../../types/ChatEvent';
import type { ClientChatMessage } from '../../types/ChatMessage';
import type { ChatSessionType } from '../../types/ChatSessionType';
import type { ChatUser } from '../../types/ChatUser';

export interface ActiveChat {
  sessionType: ChatSessionType;
  roomId: string;
  targetUserId: string;
}

export interface ReceivedChatNotificationSummary {
  senders: Map<string, ChatUser>;
  messageCount: number;
}

/**
 * `settings` is deferred to a follow-up PR — exposed as `undefined`
 * so destructure-shaped consumers can already wire to it.
 */
export interface GlobalChatContextValue {
  activeChat$: BehaviorSubject<ActiveChat | undefined>;
  pendingMessages$: BehaviorSubject<ClientChatMessage[]>;
  receivedChatNotificationSummary$: BehaviorSubject<ReceivedChatNotificationSummary>;
  events$: Subject<ChatEvent>;
  storage: ChatStorageManager;
  settings: undefined;
}

export const GlobalChatContext = createContext<GlobalChatContextValue | null>(
  null,
);
